import React, { useState } from "react"
import { ToastContainer, toast } from "react-toastify"
import styles from  "../../assets/stylesheets/pages/tools/tools.module.scss"
import ApiActions from "../../actions/ApiActions"

export default function NumberManagementForTLs() {
  const [projectId, setProjectId] = useState("")
  const [numbers, setNumbers] = useState([])
  const [accountId, setAccountId] = useState("")
  const [poolId, setPoolId] = useState("")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)

  const isValidObjectId = (id) => /^[a-f\d]{24}$/i.test(id)

  const handleFetch = async () => {
    setError("")
    setNumbers([])

    if (!isValidObjectId(projectId)) {
      setError("Invalid Project ID")
      return
    }

    try {
      setLoading(true)
      const res = await ApiActions.getAllExophonesOfProject({ teleproject: projectId })

      if (res && res.poolSet && res.poolSet.pool && res.poolSet.pool[0] && res.poolSet.pool[0].numbers && res.poolSet.pool[0] ) {
        setNumbers(res.poolSet.pool[0].numbers)
        setAccountId(res.poolSet.id)
        setPoolId(res.poolSet.pool[0].poolId)
      }
      else {
        throw ("Failed to fetch calling numbers of the project")
      }

    } catch (err) {
      setError(
        (err.response && err.response.data && err.response.data.error) ||
        "Failed to fetch calling numbers of the project"
      )
    } finally {
      setLoading(false)
    }
  }

  const toggleEnable = (index) => {
    const updated = [...numbers]
    updated[index].active = !updated[index].active
    setNumbers(updated)
  }

  const handleSubmit = async () => {
    const enabledNumbers = numbers.filter((n) => n.active);

    if (enabledNumbers.length === 0) {
      toast.error("Please enable at least one number before submitting.");
      return;
    }

    try {
      const payload = {
        accountId,
        poolId,
        numbers: numbers.map((num) => ({
          ...num,
          primary: `N:${num.primary}`,
          backup: `N:${num.backup}`
        }))
      }

      const res = await ApiActions.createUpdateExophones(payload);
      toast.success("Submitted successfully!");
    } catch (err) {
      toast.error(err.response.data.error || "Failed to submit changes.");
    }
  }

  return (
    <div className={styles.tlNumberManagement}>
      <div className={styles.container}>
          <h2 className={styles.title}>Manage Numbers linked to a Project</h2>
        <div className={styles.card}>

          <input
            type="text"
            value={projectId}
            onChange={(e) => setProjectId(e.target.value)}
            placeholder="Enter Project ID"
            className={styles.input}
          />

          <button onClick={handleFetch} disabled={loading} className={styles.button}>
            {loading ? "Fetching..." : "Fetch Numbers"}
          </button>

          {error && <p className={styles.error}>{error}</p>}
        </div>

        {numbers.map((num, idx) => (
          <div
            key={idx}
            className={`${styles["number-card"]} ${num.active ? "" : styles.disabled}`}
          >
            <div className={styles["number-info"]}>
              <strong>Pool: {num.label}</strong>
              <span>Primary: {num.primary} | Region: {num.primaryRegion} | Operator: {num.primaryOperator} | Truecaller: {num.primaryTruecaller}</span>
              <span>Backup: {num.backup} | Region: {num.backupRegion} | Operator: {num.backupOperator} | Truecaller: {num.backupTruecaller}</span>
            </div>

            <label className={styles.switch}>
              <input
                type="checkbox"
                checked={num.active}
                onChange={() => toggleEnable(idx)}
              />
              <span className={styles.slider}></span>
            </label>
          </div>
        ))}

        {numbers.length > 0 && (
          <button onClick={handleSubmit} className={styles.button} style={{ marginTop: "16px" }}>
            Submit
          </button>
        )}
      </div>

      <ToastContainer />
    </div>
  )
}
